import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProductsJsmStorageManagementEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{}
>;

export const productsJsmStorageManagementEntryPoint: EntryPoint<
	ProductsJsmStorageManagementEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<ProductsJsmStorageManagementEntryPointComponent>(
		/* webpackChunkName: "async-products-jsm-storage-management", jiraSpaEntry: "async-products-jsm-storage-management" */ './ProductsJsmStorageManagement.tsx',
	),
	getPreloadProps: () => ({
		queries: {},
	}),
});
